import { Component, Host, h, Prop } from "@stencil/core";

import { Status } from "./status";

/**
 * @deprecated use ux-w-status instead.
 * see http://trumpf-ux.ux-ui-widgets.s3-website.eu-central-1.amazonaws.com/master/?path=/docs/utilities-status--status
 */
@Component({
    tag: "ux-iws-status-label",
    styleUrl: "status-label.scss",
    shadow: false,
})
export class StatusLabel {
    /** type of the production status */
    @Prop() type: Status;

    render() {
        const { type } = this;

        const getLabelColor = (type: string): string => {
            switch (type) {
                case Status.OPEN:
                case Status.ORDERED:
                case Status.UNKNOWN:
                case Status.NOT_AVAILABLE:
                case Status.UNSUBSCRIBED:
                case Status.NOT_AVAILABLE_FOR_SUBSCRIPTION:
                    return "grey";
                case Status.CANCELLED:
                case Status.CANCELED:
                case Status.FAILED:
                case Status.INSTALLATION_FAILED:
                    return "red";
                case Status.IN_PROGRESS:
                case Status.RECEIVED:
                    return "dark-blue";
                case Status.PARTLY_DELIVERED:
                case Status.IN_PRODUCTION:
                case Status.AVAILABLE:
                case Status.UPDATE_AVAILABLE:
                    return "orange";
                case Status.COMPLETE:
                case Status.COMPLETED:
                case Status.SUBSCRIBED:
                case Status.AllUpdatesSubscribed:
                    return "green";
                default:
                    return "grey";
            }
        };

        return (
            <Host
                class={`ux-iws-status-label ux-text-status ux-text-status--${getLabelColor(
                    type
                )}`}
            >
                <ux-icon
                    class="ux-iws-status-label__icon"
                    name="circle-filled"
                />
                <slot />
            </Host>
        );
    }
}
